import React, { useEffect, useState, useRef, useContext } from 'react'
import useApp from 'hooks/useApp'
import { Link } from 'react-router-dom'
import { Switch, NoData, SelectList, Layer } from 'components'
import bannerImg1 from 'images/tmp_banner_image01.png'
import styles from 'views/setting/index.module.css'
import Lib from 'library'
import axios from 'axios'
import { showEventDetailLayerState } from 'views/setting/states'
import { useRecoilState } from 'recoil'
import Native from 'library/native'

const EventDetail = ({ eventDetail }) => {

	const [showEventDetailLayer, setShowEventDetailLayer] = useRecoilState(showEventDetailLayerState)

	// 다운로드
    const downloadFile = async (fileId, fileNm) => {
		let ext = "";
		let mimeType = "";

        if (fileNm && (fileNm.split(".")).length > 0) {
            ext = (fileNm.split("."))[1];
			mimeType = `application/${ext.toLowerCase()}`
        }

		console.log("fileNm : " + fileNm);
		console.log("mimeType : " + mimeType);

		if(Native.getUserAgent() === "android") {
			Native.execute('AppManager', 'downloadFile', undefined, { url: window.location.protocol + "//" + window.location.host+'/api/comm/download/' + fileId, filename:fileNm, mimeType:mimeType});
		} else if(Native.getUserAgent() === "ios") {
			Native.execute('AppManager', 'sharePlus', undefined, { type:'url', data:window.location.protocol + "//" + window.location.host +'/api/comm/download/' + fileId, filename:fileNm});
		}

		// const options = {
		// 	method: "GET",
		// 	responseType: "arraybuffer",
		// 	headers: {},
		// 	data: {},
		// 	url: `/api/comm/download/${fileId}`,
		// 	maxContentLength: Infinity,
		// 	maxBodyLength: Infinity,
		// 	timeout: 60 * 30 * 1000,
		// 	cache: "no-cache"
		// };

		// await axios(options)
		// .then(function(response) {
		// 	console.log(response);
		// 	const url = window.URL.createObjectURL(
		// 		new Blob([response.data], {type: `${mimeType}`})
		// 	);
		// 	Lib.reqBlobFileDownlaod(url,fileNm);
		// 	setTimeout(() => {
		// 		window.URL.revokeObjectURL(url);
		// 	}, 1000);
		// })
		// .then(function() {
		// 	console.log("success");
		// })
		// .catch(function(error) {
		// 	console.log("fail");
		// });
    }

	return (
		<Layer show={showEventDetailLayer} closeLayer={() => setShowEventDetailLayer(false)} title="이벤트">
			{eventDetail ?
				<div className="page padding">
					<div className={styles["detail-title"]}>
						<p>{eventDetail.operTitle}</p>
						<span>{`${eventDetail.operStDe} ~ ${eventDetail.operEdDe}`}</span>
					</div>
					<hr className="my_30" />
					<div className={styles["detail-content"]}>
						<p className="section-cont" dangerouslySetInnerHTML={{ __html: eventDetail.operConts }}></p>

						<div className="img-box mt_20">
							{/*	[이벤트상세에서 목록이미지 삭제. 20230128]
							{eventDetail.mainMultiAtchFileList && 
								eventDetail.mainMultiAtchFileList.map((item, index) => {
									return (
										<div key={index} className="img-box">
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									)
								})
							}
							*/}
							{eventDetail.dtlMultiAtchFileList 
								&& eventDetail.dtlMultiAtchFileList.map((item, index) => {
									return (
										<div key={index} className="img-box">
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									)
								})
							}
						</div>

						<div className="img-box mt_20">
							{eventDetail.attachMultiAtchFileList && 
								eventDetail.attachMultiAtchFileList.map((item, index) => {
									return (
										<button type="button" className="btn" onClick={() => downloadFile(item.sstmFileId, item.orignFileNm)}>
											{`${item.orignFileNm} 파일 다운로드`}
										</button>
									)
								})
							}
							{/*
								eventDetail.attachMultiAtchFileList && 
								eventDetail.attachMultiAtchFileList.map((item, index) => {
									return (
										<div key={index} className="img-box">
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									)
								})
							*/}
						</div>
					</div>
				</div>
				:
				<div className="page padding">
					<div className="skeleton" style={{ width: "20rem", height: "2rem" }}></div>
					<div className="skeleton mt_10" style={{ width: "10rem", height: "2rem" }}></div>
					<hr className="my_20" />
					<p className="skeleton" style={{ height: "15rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
				</div>
			}
		</Layer>
	)
}


export default EventDetail

